import { CardHeader } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledCardHeader = styled(CardHeader)({
  border: 'none',
});
